import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "underlineForm" }
const _hoisted_12 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_grid_item = _resolveComponent("grid-item")!
  const _component_grid_layout = _resolveComponent("grid-layout")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_MateriallDescription = _resolveComponent("MateriallDescription")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "物料编号", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.materialNo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.materialNo) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "物料品牌", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.materialBrand,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.materialBrand) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "物料名称", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.materialName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.materialName) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "物料型号", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.materialModel,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.materialModel) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "物料代码", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.materialCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.materialCode) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "位置名称", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.location,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.location) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "创建人", -1)),
          _createVNode(_component_el_select, {
            filterable: true,
            modelValue: _ctx.listQuery.createUser,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.createUser) = $event)),
            class: "filter-item",
            placeholder: "",
            clearable: "",
            onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getUserOptionRemote('')))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOption, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.mark,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[27] || (_cache[27] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[28] || (_cache[28] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "ml-10 filter-mark" }, "红色代表状态为“待确认”物料", -1))
        ])
      ]),
      _createVNode(_component_grid_layout, {
        layout: _ctx.layouts,
        "onUpdate:layout": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.layouts) = $event)),
        "col-num": 12,
        "row-height": _ctx.rowHeight,
        "is-draggable": false,
        "is-resizable": true,
        "is-mirrored": false,
        "vertical-compact": true,
        margin: [10, 10],
        "use-css-transforms": false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layouts, (item, index) => {
            return (_openBlock(), _createBlock(_component_grid_item, {
              x: item.x,
              y: item.y,
              w: item.w,
              h: item.h,
              i: item.i,
              key: item.i,
              minW: item.minW,
              maxW: item.maxW,
              minH: item.minH,
              static: item.static,
              onResize: _ctx.handleResizedEvent,
              onResized: _ctx.handleResizedEvent
            }, {
              default: _withCtx(() => [
                (index === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
                        ref_for: true,
                        ref: rf => { if (rf) _ctx.tableDataRef[index] = rf },
                        dataList: _ctx.list,
                        columnAllData: _ctx.columnAllData,
                        tableName: _ctx.TableName,
                        permissionName: _ctx.permissionName,
                        showSelection: false,
                        isShowPagination: false,
                        handleDefaultWidth: 120,
                        highlightCurrentRow: true,
                        layoutHeight: true,
                        newHpx: _ctx.newHpx,
                        canRefresh: false,
                        canChangeColumn: false,
                        style: {"height":"calc(100% )","overflow":"hidden"},
                        tableRowClassName: _ctx.tableRowClassName,
                        onRowClick: _ctx.handleRowClick,
                        onCommandChange: _ctx.handleCommand
                      }, {
                        max: _withCtx((scope) => [
                          _createElementVNode("span", null, [
                            (scope.row.max)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  effect: "dark",
                                  placement: "top-start"
                                }, {
                                  content: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                                    _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.max?.updateTime), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[31] || (_cache[31] = _createElementVNode("i", {
                                      class: "iconfont icon-tubiao-30",
                                      style: {"font-size":"14px"}
                                    }, null, -1))
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'max')), 1)
                          ])
                        ]),
                        min: _withCtx((scope) => [
                          _createElementVNode("span", null, [
                            (scope.row.min)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  effect: "dark",
                                  placement: "top-start"
                                }, {
                                  content: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                                    _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.min?.updateTime), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[33] || (_cache[33] = _createElementVNode("i", {
                                      class: "iconfont icon-tubiao-30",
                                      style: {"font-size":"14px"}
                                    }, null, -1))
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'min')), 1)
                          ])
                        ]),
                        "operation-action": _withCtx((scope) => [
                          _createVNode(_component_CommandRender, {
                            scopeRow: scope.row,
                            codeList: _ctx.btnList,
                            permissionName: _ctx.permissionName,
                            onCommandChange: _ctx.handleCommand
                          }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"])
                        ]),
                        _: 1
                      }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "tableRowClassName", "onRowClick", "onCommandChange"])), [
                        [_directive_loading, _ctx.listLoading]
                      ]),
                      _withDirectives(_createVNode(_component_el_pagination, {
                        class: "mt-20",
                        total: _ctx.total,
                        currentPage: _ctx.listQuery.page,
                        "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.page) = $event)),
                        "page-size": _ctx.listQuery.size,
                        "page-sizes": _ctx.pageSizes,
                        onSizeChange: _ctx.handleSizeChange,
                        onCurrentChange: _ctx.handleCurrentChange,
                        layout: "total, sizes, prev, pager, next"
                      }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
                        [_vShow, _ctx.total > 0]
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["x", "y", "w", "h", "i", "minW", "maxW", "minH", "static", "onResize", "onResized"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["layout", "row-height"])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.addPriceVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: _ctx.pathApi,
          "onUpdate:visibel": _cache[12] || (_cache[12] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api"]))
      : _createCommentVNode("", true),
    (_ctx.addPriceVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 1,
          id: 0,
          initFormData: _ctx.initPriceFormData,
          fromFieldData: _ctx.fromPriceFieldData,
          dialogFormVisible: _ctx.addPriceVisible,
          api: "materialInquiry",
          "onUpdate:visibel": _cache[14] || (_cache[14] = ($event: any) => (_ctx.addPriceVisible = false)),
          onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, {
          front: _withCtx(() => [
            _createVNode(_component_MateriallDescription, { detail: _ctx.activeRow }, null, 8, ["detail"])
          ]),
          _: 1
        }, 8, ["initFormData", "fromFieldData", "dialogFormVisible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.deliverVisible,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.deliverVisible) = $event)),
      title: "出库",
      width: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "dataForm",
          model: _ctx.ruleForm,
          rules: _ctx.rules,
          "label-position": "top",
          "label-width": "100px",
          class: "mb-20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form_item, {
                label: "数量",
                prop: "num"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.ruleForm.num,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ruleForm.num) = $event)),
                    type: "number",
                    min: 0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "位置",
                prop: "locationId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree_select, {
                    filterable: true,
                    data: _ctx.locationOption,
                    "render-after-expand": false,
                    modelValue: _ctx.ruleForm.locationId,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ruleForm.locationId) = $event)),
                    placeholder: "输入关键字搜索",
                    "check-strictly": "",
                    "node-key": "id",
                    props: { children: 'children', label: 'name' },
                    clearable: true
                  }, null, 8, ["data", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.deliverVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleReturn
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}